<div class="add-container">
    <app-sidenav-header [title]="title"></app-sidenav-header>
    <div class="p-24" class="form-section pr-10">
      <form [formGroup]="createInstanceForm" class="p-8">
        <div class="flex flex-col mb-16">
            <div class="flex flex-row gap-8">
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.TENANT_ID' | transloco | uppercase }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.TENANT_ID' | transloco"
                        matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="tenantId" placeholder="{{'ADD_INSTANCE.TENANT_ID' | transloco}}" class="fw-500" required>
                    <app-error [control]="createInstanceForm.get('tenantId')"></app-error>
                </div>
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.INSTANCE_NAME' | transloco | uppercase }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.INSTANCE_NAME' | transloco"
                        matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="name" placeholder="{{'ADD_INSTANCE.INSTANCE_NAME' | transloco}}" class="fw-500" required>
                    <app-error [control]="createInstanceForm.get('name')"></app-error>
                </div>
            </div>
        </div>
        <div class="flex flex-col mb-16">
            <div class="flex flex-row gap-8">
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.RANDOM_SUFFIX' | transloco | uppercase }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.RANDOM_SUFFIX' | transloco"
                        matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="randomSuffix" placeholder="{{'ADD_INSTANCE.RANDOM_SUFFIX' | transloco}}" class="fw-500" required>
                    <app-error [control]="createInstanceForm.get('randomSuffix')"></app-error>
                </div>
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.DATA_ZONE' | transloco | uppercase }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.DATA_ZONE' | transloco"
                        matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <mat-select [formControl]="createInstanceForm.get('dataZone')" class="fw-500 form-select" [placeholder]="'ADD_INSTANCE.DATA_ZONE' | transloco" required>
                        <mat-option *ngFor="let zone of dataZone" [value]="zone">{{ zone | titlecase }}</mat-option>
                    </mat-select>
                    <app-error [control]="createInstanceForm.get('dataZone')"></app-error>
                </div>
            </div>
        </div>
        <div class="flex flex-col mb-16">
            <div class="flex flex-row gap-8">
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.DEPLOYMENT_CLASS' | transloco | uppercase }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.DEPLOYMENT_CLASS' | transloco"
                        matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <mat-select [formControl]="createInstanceForm.get('deploymentClass')" class="fw-500 form-select" [placeholder]="'ADD_INSTANCE.DEPLOYMENT_CLASS' | transloco" required>
                        <mat-option *ngFor="let deploy of deploymentClass" [value]="deploy">{{ deploy | titlecase }}</mat-option>
                    </mat-select>                    
                    <app-error [control]="createInstanceForm.get('deploymentClass')"></app-error>
                </div>
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.STATUS' | transloco | uppercase }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.STATUS' | transloco"
                        matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <mat-select [formControl]="createInstanceForm.get('status')" class="fw-500 form-select" [placeholder]="'ADD_INSTANCE.STATUS' | transloco" required>
                      <mat-option *ngFor="let statuses of status" [value]="statuses">{{ statuses | titlecase }}</mat-option>
                    </mat-select>
                    <app-error [control]="createInstanceForm.get('status')"></app-error>
                </div>
            </div>
        </div>
        <div class="flex flex-col mb-16">
            <div class="flex flex-row gap-8">
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.PRIMARY_CLOUD_REGION' | transloco | uppercase }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.PRIMARY_CLOUD_REGION' | transloco"
                        matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="primaryCloudRegion" placeholder="{{'ADD_INSTANCE.PRIMARY_CLOUD_REGION' | transloco}}" class="fw-500" required>
                    <app-error [control]="createInstanceForm.get('primaryCloudRegion')"></app-error>
                </div>
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.SECONDARY_CLOUD_REGION' | transloco | uppercase }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.SECONDARY_CLOUD_REGION' | transloco"
                        matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="secondaryCloudRegion" placeholder="{{'ADD_INSTANCE.SECONDARY_CLOUD_REGION' | transloco}}" class="fw-500" required>
                    <app-error [control]="createInstanceForm.get('secondaryCloudRegion')"></app-error>
                </div>
            </div>
        </div>
        <div class="flex flex-col mb-16">
            <div class="flex flex-row gap-8">
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.MANAGEMENT_TYPE' | transloco | uppercase }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.MANAGEMENT_TYPE' | transloco"
                        matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <mat-select [formControl]="createInstanceForm.get('managementType')" class="fw-500 form-select" [placeholder]="'ADD_INSTANCE.MANAGEMENT_TYPE' | transloco" required>
                      <mat-option *ngFor="let type of managementType" [value]="type">{{ type | titlecase }}</mat-option>
                    </mat-select>                    
                    <app-error [control]="createInstanceForm.get('managementType')"></app-error>
                </div>
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.EXTERNAL_ORIGINATION' | transloco | uppercase }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.EXTERNAL_ORIGINATION' | transloco"
                        matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <mat-select [formControl]="createInstanceForm.get('externalOrigination')" class="fw-500 form-select" [placeholder]="'ADD_INSTANCE.EXTERNAL_ORIGINATION' | transloco" required>
                      <mat-option *ngFor="let origin of externalOrigination" [value]="origin">{{ origin | titlecase }}</mat-option>
                    </mat-select>
                    <app-error [control]="createInstanceForm.get('externalOrigination')"></app-error>
                </div>
            </div>
        </div>
        <div class="flex flex-col mb-16">
            <div class="flex flex-row gap-8">
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.ADO_PIPELINE' | transloco | uppercase }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.ADO_PIPELINE' | transloco"
                        matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="adoPipeline" placeholder="{{'ADD_INSTANCE.ADO_PIPELINE' | transloco}}" class="fw-500" required>
                    <app-error [control]="createInstanceForm.get('adoPipeline')"></app-error>
                </div>
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.ADO_VARIABLE_GROUP' | transloco | uppercase }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.ADO_VARIABLE_GROUP' | transloco"
                        matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="adoVariableGroup" placeholder="{{'ADD_INSTANCE.ADO_VARIABLE_GROUP' | transloco}}" class="fw-500" required>
                    <app-error [control]="createInstanceForm.get('adoVariableGroup')"></app-error>
                </div>
            </div>
        </div>
        <div class="flex flex-col mb-16">
            <div class="flex flex-row gap-8">
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.AKS_VERSION' | transloco | uppercase }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.AKS_VERSION' | transloco"
                        matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="AKSVersion" placeholder="{{'ADD_INSTANCE.AKS_VERSION' | transloco}}" class="fw-500" required>
                    <app-error [control]="createInstanceForm.get('AKSVersion')"></app-error>
                </div>
                <div class="flex flex-col form-fields mb-16">
                    <div class="flex flex-row justify-start items-center">
                        <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.DYNATRACE_URL' | transloco | uppercase }}</label>
                        <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.DYNATRACE_URL' | transloco"
                        matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                    </div>
                    <input formControlName="dynatraceUrl" placeholder="{{'ADD_INSTANCE.DYNATRACE_URL' | transloco}}" class="fw-500">
                    <app-error [control]="createInstanceForm.get('dynatraceUrl')"></app-error>
                </div>
            </div>
        </div>
      </form>
      <div>
        <div class="flex flex-row justify-between items-center">
          <div class="mat-subheading-2 mb-0 fs-14 fw-700 pt-16 pb-16 pr-10">
            {{'ADD_INSTANCE.TEMENOS_PRODUCTS' | transloco | uppercase }}
          </div>
          <mat-divider class="divider-product"></mat-divider>
          <div (click)="addProductsOccurrence()" class="flex flex-row justify-center items-center fw-500 cursor-pointer pl-10">
            <mat-icon class="mr-4 icon-sm" svgIcon="add"></mat-icon>
            <span class="link-text">{{'ADD_INSTANCE.ADD' | transloco }}</span>
          </div>
        </div>
        <ng-container *ngFor="let occurrence of productOccurrences; let i = index">
          <form [formGroup]="productForm[occurrence]" class="mb-20 p-12 media-form">
            <div class="flex flex-row justify-end items-center fw-500 pb-8">
              <mat-icon (click)="deleteProductsOccurrence(i)" class="mr-4 icon-sm cursor-pointer" svgIcon="remove"></mat-icon>
              <span (click)="deleteProductsOccurrence(i)" class="link-text cursor-pointer">{{'ADD_INSTANCE.REMOVE' | transloco }}</span>
            </div>
            <div class="flex flex-row gap-8">
              <div class="flex flex-col form-fields mb-16">
                <div class="flex flex-row justify-start items-center">
                  <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.NAME' | transloco | uppercase }}</label>
                  <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.NAME' | transloco"
                    matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                </div>
                <input formControlName="name" placeholder="{{'ADD_INSTANCE.NAME' | transloco}}" class="fw-500" required>
                <app-error [control]="productForm[occurrence]?.get('name')"></app-error>
              </div>
              <div class="flex flex-col form-fields mb-16">
                <div class="flex flex-row justify-start items-center">
                  <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.VERSION' | transloco | uppercase }}</label>
                  <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.VERSION' | transloco"
                    matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                </div>
                <input formControlName="version" placeholder="{{'ADD_INSTANCE.VERSION' | transloco}}" class="fw-500" required>
                <app-error [control]="productForm[occurrence]?.get('version')"></app-error>
              </div>
            </div>
          </form>
        </ng-container>
      </div>
      <div>
        <div class="flex flex-row justify-between items-center">
          <div class="mat-subheading-2 mb-0 fs-14 fw-700 pt-16 pb-16 pr-10">
            {{'ADD_INSTANCE.ENDPOINTS' | transloco | uppercase }}
          </div>
          <mat-divider class="divider"></mat-divider>
          <div (click)="addMediaOccurrence()" class="flex flex-row justify-center items-center fw-500 cursor-pointer pl-10">
            <mat-icon class="mr-4 icon-sm" svgIcon="add"></mat-icon>
            <span class="link-text">{{'ADD_INSTANCE.ADD' | transloco }}</span>
          </div>
        </div>
        <ng-container *ngFor="let occurrence of occurrences; let i = index">
          <form [formGroup]="endPointForm[occurrence]" class="mb-20 p-12 media-form">
            <div class="flex flex-row justify-end items-center fw-500 pb-8">
              <mat-icon (click)="deleteMediaOccurrence(i)" class="mr-4 icon-sm cursor-pointer" svgIcon="remove"></mat-icon>
              <span (click)="deleteMediaOccurrence(i)" class="link-text cursor-pointer">{{'ADD_INSTANCE.REMOVE' | transloco }}</span>
            </div>
            <div class="flex flex-row gap-8">
              <div class="flex flex-col form-fields mb-16">
                <div class="flex flex-row justify-start items-center">
                  <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.NAME' | transloco | uppercase }}</label>
                  <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.NAME' | transloco"
                    matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                </div>
                <input formControlName="name" placeholder="{{'ADD_INSTANCE.NAME' | transloco}}" class="fw-500" required>
                <app-error [control]="endPointForm[occurrence]?.get('name')"></app-error>
              </div>
              <div class="flex flex-col form-fields mb-16">
                <div class="flex flex-row justify-start items-center">
                  <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.DESCRIPTION' | transloco | uppercase }}</label>
                  <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.DESCRIPTION' | transloco"
                    matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                </div>
                <input formControlName="description" placeholder="{{'ADD_INSTANCE.DESCRIPTION' | transloco}}" class="fw-500" required>
                <app-error [control]="endPointForm[occurrence]?.get('description')"></app-error>
              </div>
            </div>

            <div class="flex flex-row gap-8">
              <div class="flex flex-col form-fields mb-16">
                <div class="flex flex-row justify-start items-center">
                  <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.URL' | transloco | uppercase }}</label>
                  <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.URL' | transloco"
                    matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                </div>
                <input formControlName="url" placeholder="{{'ADD_INSTANCE.URL' | transloco}}" class="fw-500" required>
                <app-error [control]="endPointForm[occurrence]?.get('url')"></app-error>
              </div>
              <div class="flex flex-col form-fields mb-16">
                <div class="flex flex-row justify-start items-center">
                  <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'ADD_INSTANCE.USETYPE' | transloco | uppercase }}</label>
                  <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_INSTANCE.USETYPE' | transloco"
                    matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
                </div>
                <mat-select [formControl]="endPointForm[occurrence].get('useType')" class="fw-500 form-select" [placeholder]="'ADD_INSTANCE.USETYPE' | transloco">
                    <mat-option *ngFor="let types of useType" [value]="types">{{ types | titlecase }}</mat-option>
                </mat-select>                  
                <app-error [control]="endPointForm[occurrence]?.get('useType')"></app-error>
              </div>
            </div>
          </form>
        </ng-container>
      </div>
    </div>
  
    <div class="footer pt-16" >
      <div class="flex flex-row justify-end gap-x-6">
        <button class="white" type="button" (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' | transloco}}</button>
        <button class="accent" type="button" (click)="createDeployment()">{{'ADD_INSTANCE.SUBMIT' | transloco}}</button>
      </div>
    </div>
</div>
  
  <div class="overlay" *ngIf="isLoading">
    <mat-spinner diameter="24" color="primary" mode="indeterminate"></mat-spinner>
  </div>
  
  